import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import { getStateScrapes } from 'utils/functions'
import type { CouncilsState, CouncilsOwner } from '../types'
import { getOwnerStats } from './helpers'

const noCouncilsConfig = {
  owners: [],
  activeState: null,
  isInitalized: false,
  isLoading: true,
  hasError: false,
}

interface SetStatsPayload {
  owners: CouncilsOwner[]
  state: string
}

const initialState: CouncilsState = { ...noCouncilsConfig }

export const councilsSlice = createSlice({
  name: 'Councils',
  initialState,
  reducers: {
    fetchStats: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setStats: (state, action: PayloadAction<SetStatsPayload>) => {
      state.owners = action.payload.owners
      state.activeState = action.payload.state
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchStatsFailed: (state) => {
      state.owners = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchOwnerStats = (state = '') => async (dispatch) => {
  try {
    dispatch(fetchStats())
    const owners = await getOwnerStats(state)
    dispatch(
      setStats({
        state,
        owners,
      }),
    )
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchStatsFailed())
  }
}

export const fetchOwnerScrapes = (state: string, yearMonth: any) => async (dispatch) => {
    const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenData.token}`,
      },
    }
    try {
      dispatch(fetchStats())
      const owners = await getStateScrapes(state, yearMonth, config)
      // console.log("owners", owners)
      dispatch(
        setStats({
          state,
          owners,
        }),
      )
    } catch (error) {
      message.error('Error gettings stats')
      dispatch(fetchStatsFailed())
    }
}

// Actions
export const { fetchStats, setStats, fetchStatsFailed } = councilsSlice.actions

export default councilsSlice.reducer
